import { Injectable } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import {
  StatisticQuery,
  StatisticQueryControllerService,
} from '@osos/shared/api';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ApiUtilsService } from '../..';

@Injectable({
  providedIn: 'root',
})
export class StatisticQueryDataService extends StatisticQueryControllerService {
  constructor(private apiHelper: ApiUtilsService) {
    super();
  }

  //TODO move the part that is related to validation to another place, and only return the part
  //That is related to the response only
  public checkEntityQueriesCount(
    entityId: string,
  ): Observable<ValidationErrors> {
    return this.count({
      entity: entityId,
    }).pipe(
      switchMap((count) => {
        return count?.count == 0 ? of({ hasNoQueries: true }) : of(null);
      }),
    );
  }

  public checkEntityQueriesCountExcludingIds(
    entityId: string,
    excludedIds = [],
  ): Observable<ValidationErrors | null> {
    if (excludedIds.length > 0) {
      return this.count({
        entity: entityId,
        ...this.apiHelper.prepareWhere<StatisticQuery>({
          id: { nin: excludedIds },
        }),
      }).pipe(
        switchMap((count) => {
          return count?.count == 0
            ? of({ allQueriesConsumed: true })
            : of(null);
        }),
      );
    } else {
      return of(null);
    }
  }
}
